























































































































// eslint-disable-next-line no-unused-vars
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import dashModule from '@/store/modules/DashboardModule';
import { Capability, IndividualDataTableDashboardPage } from '@/models/hcad/shared/dashboard';
import { questions, capabilityNameToQuestionsMap } from '@/copy/interview-questions';

@Component
export default class InterviewGuide extends Vue
{
    @Prop({ type: String, required: true })
    readonly defaultCapability!: string;

    @Prop({type: Object, required: true})
    page!: IndividualDataTableDashboardPage;
    
    @Prop({type: Array, required: true})
    displayCapabilities!: { capability: Capability, index: number }[];

    selectedCapabilityIndex = 0;
    selectedQuestionIndex = 0;

    get dashboard()
    {
        if (!dashModule.activeDashboard) throw new Error('No dashboard loaded');
        return dashModule.activeDashboard;
    }

    get interviewQuestionsLabel()
    {
        if (this.page.interviewQuestionLabelOverride && this.page.interviewQuestionLabelOverride.trim().length > 0)
        {
            return this.page.interviewQuestionLabelOverride;
        }
        return 'Interview Questions';
    }

    get selectedCapability()
    {
        return ((this.selectedCapabilityIndex >= 0 && this.selectedCapabilityIndex < this.displayCapabilities.length)
            ? this.displayCapabilities[this.selectedCapabilityIndex].capability
            : null);
    }

    get selectedCapabilityName()
    {
        return this.selectedCapability ? this.selectedCapability.name : '';
    }

    get interviewQuestions()
    {
        if (this.selectedCapabilityName)
        {
            const categories = this.dashboard.capabilities;
            const caps = categories.flatMap((cap) => 
            {
                return cap.capabilities.map((subCap) => 
                {
                    return { ...subCap, name: subCap.name || cap.name };
                });
            });

            const found = caps.find((cap) => cap.name === this.selectedCapabilityName);
            if (found)
            {
                if (found.interviewQuestions && found.interviewQuestions.length > 0)
                {
                    return found.interviewQuestions;
                }
                else
                {
                    // Fall back to old behavior
                    const iqKeys = capabilityNameToQuestionsMap.get(this.selectedCapabilityName);
                    if (iqKeys)
                    {
                        return iqKeys.map((iqKey) => 
                        {
                            const questionHTML = questions.get(iqKey);
                            return questionHTML ? questionHTML : '';
                        });
                    }
                }
            }
            else
            {
                return ['not found', caps.filter(a=>a.name).map(a=>a.name)];
            }
        }
        return [];
    }

    @Watch('selectedCapabilityIndex')
    async onSelectedCapabilityIndexChanged() // fixes loss of slider on question tab when changing capability tab
    {
        this.selectedQuestionIndex = -1;
        await Vue.nextTick();
        this.selectedQuestionIndex = 0;
    }

    beforeMount()
    {
        this.selectedCapabilityIndex = this.displayCapabilities.findIndex(({ capability: c }) => c.name === this.defaultCapability);
    }
}
